import React from "react";
import downloadSuccess from "../assets/images/SalesJourney/Common/DownloadSuccess.svg";
import emailSuccess from "../assets/images/Reports/emailSuccess.svg";
import "@frameworks/web/stylesheets/components/Reports/HoldingReports/SmcasePopupSuccess.scss";
var SuccessPopup = function (props) {
    return (React.createElement("div", { className: "modalBackground" },
        React.createElement("div", { className: "modalContainer" },
            React.createElement("div", { className: "smallcase-popup-success" },
                React.createElement("div", { className: "modal-header bg_aqua_white" }, props.Title),
                React.createElement("div", { className: "smallcase-popup-success-body" },
                    props.operation == "email_download" ||
                        props.operation == "email" ? (React.createElement("img", { className: "downloadSuccess", src: emailSuccess, alt: "Email Successful" })) : props.operation == "download" ? (React.createElement("img", { className: "downloadSuccess", src: downloadSuccess, alt: "Download Successful" })) : null,
                    React.createElement("label", { className: "update-message DMSans_16_500 txt_primaryGrey" }, props.message ? (React.createElement("span", { dangerouslySetInnerHTML: { __html: props.message } })) : ("Your request was successfully processed.")),
                    React.createElement("span", { className: "action-post-success" },
                        React.createElement("button", { className: "txt-midnight-blue DMSansMedium_18_500 d-flex align-items-center", onClick: function () {
                                props.setDownloadSuccess(false);
                                setTimeout(function () {
                                    props.closeDropdown && props.closeDropdown(false);
                                }, 0);
                                if (props === null || props === void 0 ? void 0 : props.sendBack) {
                                    props.goBack();
                                }
                                else {
                                    props.setUrl();
                                }
                            } },
                            React.createElement("i", { className: "edel-icon-right-arrow twist EncodeSansR_15_400 pb-0" }),
                            "Go Back ",
                            props.pageName && "to ".concat(props.pageName))))))));
};
export default SuccessPopup;
